// extracted by mini-css-extract-plugin
export default {"connection":"SectionFooter_connection__IhFVU","root":"SectionFooter_root__7yMBe","greenIcon":"SectionFooter_greenIcon__h-+ZH","redIcon":"SectionFooter_redIcon__6hT-K"};